import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from "rxjs";
import { ProblemGetModel } from '@app/models/failure/problem.model';
import {
  PeaClosureModel, PeaDashboardCountModel, PeaDashboardModel, PeaFailReasonModel, PeaGetModel, PeaHazardRating, PeaPostHazardRating, PeaSiteCategoryModel, PEASiteNameModel,
  PeaSiteUserModel, PeaSnoozeModel, PeaSuffixClosureModel
} from '@app/models/failure/pea.model';
import { PEAActionModel, PeaIncidentTypeModel, PEARemindersModel } from '@app/models/failure/pea.model';

@Injectable({ providedIn: 'root' })
export class PeaService {

  private apiUrl = `${environment.apiUrl}/api/PEA/`;

  constructor(private httpClient: HttpClient) { }

  public getSincsDashboardCount(searchValue: any): Observable<PeaDashboardCountModel[]> {
    return this.httpClient.post<PeaDashboardCountModel[]>(`${this.apiUrl}/dashBoardCount`,searchValue,{});
  }

  public getSincsDashboard(searchValue: any): Observable<PeaDashboardModel[]> {
    return this.httpClient.post<PeaDashboardModel[]>(`${this.apiUrl}/dashBoard`,searchValue,{});
  }

  public getIncidentTypes(): Observable<PeaIncidentTypeModel[]> {
    return this.httpClient.get<PeaIncidentTypeModel[]>(`${this.apiUrl}/incidentType`, {});
  }
  public getPEADashboardCount(searchData: any) {
    const options = new HttpHeaders({ 'Content-Type': 'application/json' })
      .set('X-DashBoardCount-Filters', JSON.stringify(searchData));
    return this.httpClient.get(`${this.apiUrl}/dashBoardCount`, { headers: options });
  }
  public getPEAById(peaId: number) {
    return this.httpClient.get<PeaGetModel>(`${this.apiUrl}${peaId}`, {});
  }
  public postPEA(peaData) {
    return this.httpClient.post(`${this.apiUrl}`, peaData, {});
  }

  public getSnoozeRemindersByUserId(userId: number, snoozeTime: number): Observable<PeaSnoozeModel[]> {
    return this.httpClient.get<PeaSnoozeModel[]>(`${this.apiUrl}/snooze/reminders/${userId}/${snoozeTime}`, {});
  }
  public getPEAActions(peaId: number): Observable<PEAActionModel[]> {
    return this.httpClient.get<PEAActionModel[]>(`${this.apiUrl}/actions/${peaId}`, {});
  }
  public postCreateAction(peaAction) {
    return this.httpClient.post(`${this.apiUrl}/action/`, peaAction, {});
  }
  public postHazardRating(paramsData) {
    return this.httpClient.post(`${this.apiUrl}/hazardRating/`, paramsData, {});
  }

  public getPEASiteName(): Observable<PEASiteNameModel[]> {
    return this.httpClient.get<PEASiteNameModel[]>(`${this.apiUrl}/SiteName`, {});
  }
  public getPEADashboard(searchData) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
      .set('X-DashBoard-Filters', JSON.stringify(searchData));
    return this.httpClient.get(`${this.apiUrl}/dashBoard`, { headers });
  }
  public getSuffixClosure(peaId: number): Observable<PeaClosureModel[]> {
    return this.httpClient.get<PeaClosureModel[]>(`${this.apiUrl}/suffixClosure/${peaId}`, {});
  }
  public getPeafailreason(suffixId: number): Observable<PeaFailReasonModel[]> {
    return this.httpClient.get<PeaFailReasonModel[]>(`${this.apiUrl}/peaProblemReason/${suffixId}`, {});
  }

  public getPeaSitecategory(discipline: string, deliveryUnit: string): Observable<PeaSiteCategoryModel[]> {
    return this.httpClient.get<PeaSiteCategoryModel[]>(`${this.apiUrl}/localSiteCategory/${discipline}/${deliveryUnit}`, {});
  }
  public getHazardRating(peaId: number) {
    return this.httpClient.get<PeaHazardRating>(`${this.apiUrl}/spGetHazardRatings/${peaId}`, {});
  }

  public getLinkedPeaRecord(peaCode: string) {
    return this.httpClient.get(`${this.apiUrl}/search/${peaCode}`, { responseType: 'text' as 'json' });
  }
  public postLinkPeaRecord(dataObj) {
    return this.httpClient.post(`${this.apiUrl}/linkRecords`, dataObj, {});
  }


  public postSavePEA(savePEAData) {
    return this.httpClient.post(`${this.apiUrl}`, savePEAData, {});
  }
  public getReminders(userId) {
    return this.httpClient.get<PEARemindersModel[]>(`${this.apiUrl}/${userId}`, {});
  }

  public getPEASites(userId): Observable<PeaSiteUserModel[]> {
    return this.httpClient.get<PeaSiteUserModel[]>(`${this.apiUrl}/sites/${userId}`, {});
  }

  public getRemindersByUserId(userId: number): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.apiUrl}/reminders/${userId}`, {});
  }
  public postSignalSights(dataObj) {
    return this.httpClient.post(`${this.apiUrl}/signalSight`, dataObj, {});
  }
}
